export default __webpack_public_path__ + "static/media/guide_041.60f423c7.md";